import moment from 'moment'
import { i18n } from '../plugins/i18n'

export function basicDateFormat(date, format = i18n.t('format.date.default')) {
  return date ? moment( date ).format(format) : ''
}

export function basicDateTimeFormat(date, format = i18n.t('format.datetime.default')) {
  return date ? moment( date ).format(format) : ''
}